import React from "react"
import {
  FormControlLabel,
  FormControlLabelText,
} from "../gluestack/form-control"

interface FieldLabelProps {
  label?: string
  required?: boolean
}

export const FieldLabel: React.FC<FieldLabelProps> = ({
  label /*, required*/,
}) => {
  if (!label) return null
  return (
    <FormControlLabel>
      <FormControlLabelText className="text-secondary-600 text-sm italic">
        {label}
      </FormControlLabelText>
    </FormControlLabel>
  )
}
